import { ThemeContext } from 'app/common/ThemeContext';
import { useEffect, useState, type ReactNode } from 'react';
import { GetUserSystemConfigurationResponse } from 'ais-facade-api/api';
import { useGetTheme } from 'hooks/useGetTheme';
import { useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import styles from 'App.module.scss';

type ThemeProviderProps = {
  children: ReactNode;
  ui?: GetUserSystemConfigurationResponse;
};

export const ThemeProvider = ({ children, ui }: ThemeProviderProps) => {
  const theme = useGetTheme(ui?.result?.feDefaultStyleUI?.toLowerCase());
  const [isWithPanel, setIsWithPanel] = useState<boolean>(false);
  const location = useLocation();

  const WITH_SIDES = ['areas', 'routes', 'analytics'];
  useEffect(() => {
    if (WITH_SIDES.includes(location.pathname.split('/')[1])) {
      setIsWithPanel(true);
    } else {
      setIsWithPanel(false);
    }
  }, [location]);

  return (
    <ThemeContext.Provider value={theme}>
      <div
        className={clsx({
          [styles[`${theme}`]]: theme,
          [styles.with_side_panel]: isWithPanel,
        })}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  );
};
